import { render } from "./Project3View.vue?vue&type=template&id=162804c5&scoped=true&ts=true"
import script from "./Project3View.vue?vue&type=script&lang=ts"
export * from "./Project3View.vue?vue&type=script&lang=ts"

import "./Project3View.vue?vue&type=style&index=0&id=162804c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162804c5"]])

export default __exports__